import React from 'react'
import { bool, string, func, object } from 'prop-types'
import { Formik } from 'formik'

import Modal from './Modal'

const EditModal = ({ isActive, title, onClose, onSubmit, children, initialValues, isSubmitting }) => {
  return (
    <Modal
      isActive={isActive}
      onToggleModal={onClose}
    >
      <div className='EditModal'>
        <h3 className='Modal__h3'>{title}</h3>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
        >
          {(formik) =>  {
            const { values, handleSubmit, handleChange } = formik
            return (
             <form
               className='EditModal__form'
               onSubmit={handleSubmit}
             >
               {children ? children(formik) : (
                 <textarea
                   name="data"
                   className="Input"
                   onChange={handleChange}
                   value={values.data}
                   rows="4"
                   cols="50"
                 />
               )}
               <div className="EditModal__form__buttons">
                 <button
                   className='Button Button--gray-light'
                   onClick={onClose}
                   type="button"
                 >
                   Cancel
                 </button>

                 <button
                   className='Button Button--blue'
                   type="submit"
                   disabled={isSubmitting}
                 >
                   {isSubmitting ? 'Updating...' : 'Edit'}
                 </button>
               </div>
             </form>
            )
          }}
        </Formik>
      </div>
    </Modal>
  )
}

EditModal.propTypes = {
  isActive: bool.isRequired,
  title: string.isRequired,
  onClose: func.isRequired,
  onSubmit: func.isRequired,
  isSubmitting: bool,
  children: func,
  initialValues: object
}

EditModal.defaultProps = {
  initialValues: { data: '' }
}

export default EditModal
